import React from 'react';
import cn from 'clsx';
import { ColorValueStrict } from 'fronton-react';
import { Typography } from 'common/components/typography';
import { BannerHeader } from '../banner-header';
import { bannerContent } from './banner-content-styles';

type BannerContentProps = {
  className?: string;
  children?: React.ReactNode;
  title?: string;
  text?: string;
  textColor?: ColorValueStrict;
};

export const BannerContent: React.FC<BannerContentProps> = ({
  className,
  children,
  title,
  text,
  textColor,
}) => (
  <div className={cn(bannerContent, className)}>
    {children || (
      <>
        {title && <BannerHeader title={title} textColor={textColor || 'text-invert'} />}
        <Typography variant="s" size="body_long" color={textColor || 'text-invert'}>
          {text}
        </Typography>
      </>
    )}
  </div>
);
